/*
  Glisser-déposer à la souris sur les carrousels du site.

  Au doigt, le défilement horizontal fonctionne déjà nativement. À la souris,
  il fallait passer par les flèches : ce script permet d'attraper le carrousel
  et de le faire glisser.

  Trois précautions :
    - on n'intervient qu'à la souris (`pointerType === 'mouse'`), pour ne pas
      se superposer au défilement tactile natif ;
    - un déplacement n'est reconnu qu'au-delà d'un seuil, et le clic qui suit
      est alors annulé : sans ça, faire glisser depuis une carte ouvrirait la
      fiche produit au relâchement ;
    - l'accrochage des vignettes (scroll-snap) est suspendu pendant le
      glissement, puis rétabli, sinon le mouvement est saccadé.

  Les flèches, la molette et la navigation au clavier restent inchangées.
*/
(function () {
  'use strict';

  var SEUIL = 6; // px de déplacement avant de considérer que c'est un glissement

  function estDefilable(piste) {
    return piste.scrollWidth > piste.clientWidth + 1;
  }

  function activer(piste) {
    if (piste.dataset.alcoDrag) return;
    piste.dataset.alcoDrag = 'ok';

    var actif = false;
    var glisse = false;
    var xDepart = 0;
    var scrollDepart = 0;
    var snapInitial = '';
    var comportementInitial = '';
    var pointerId = null;

    piste.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse' || e.button !== 0) return;
      if (!estDefilable(piste)) return;
      // On laisse tranquilles les éléments qui ont leur propre usage du clic.
      if (e.target.closest('button, input, select, textarea, [contenteditable="true"]')) return;

      actif = true;
      glisse = false;
      pointerId = e.pointerId;
      xDepart = e.clientX;
      scrollDepart = piste.scrollLeft;
      snapInitial = piste.style.scrollSnapType;
      comportementInitial = piste.style.scrollBehavior;
    });

    piste.addEventListener('pointermove', function (e) {
      if (!actif || e.pointerId !== pointerId) return;

      var dx = e.clientX - xDepart;
      if (!glisse) {
        if (Math.abs(dx) < SEUIL) return;
        glisse = true;
        piste.classList.add('alco-drag-actif');
        piste.style.scrollSnapType = 'none';
        // Posé en style direct, et non par la classe CSS : plusieurs
        // carrousels déclarent `scroll-behavior: smooth`, qui l'emporterait
        // et rendrait le mouvement mou et en retard sur la main.
        piste.style.scrollBehavior = 'auto';
        try {
          piste.setPointerCapture(pointerId);
        } catch (err) {
          /* capture indisponible : le glissement fonctionne quand même */
        }
      }

      e.preventDefault();
      piste.scrollLeft = scrollDepart - dx;
    });

    function terminer(e) {
      if (!actif || (e && e.pointerId !== pointerId)) return;
      actif = false;

      if (glisse) {
        piste.classList.remove('alco-drag-actif');
        piste.style.scrollSnapType = snapInitial;
        piste.style.scrollBehavior = comportementInitial;
        try {
          piste.releasePointerCapture(pointerId);
        } catch (err) {
          /* rien à libérer */
        }

        // Le relâchement déclenche un clic : on l'absorbe, sinon un simple
        // glissement ouvrirait le produit sous le curseur.
        var absorber = function (ev) {
          ev.preventDefault();
          ev.stopPropagation();
        };
        piste.addEventListener('click', absorber, true);
        window.setTimeout(function () {
          piste.removeEventListener('click', absorber, true);
        }, 0);
      }

      glisse = false;
      pointerId = null;
    }

    piste.addEventListener('pointerup', terminer);
    piste.addEventListener('pointercancel', terminer);
    piste.addEventListener('lostpointercapture', terminer);

    // Empêche le glisser-déposer natif des images et des liens.
    piste.addEventListener('dragstart', function (e) {
      if (actif) e.preventDefault();
    });

    piste.classList.add('alco-drag-pret');
  }

  function balayer(racine) {
    var pistes = (racine || document).querySelectorAll('[id^="Slider-"], .phare__liste');
    for (var i = 0; i < pistes.length; i++) {
      var p = pistes[i];
      // La barre d'annonces défile toute seule : ce n'est pas un carrousel
      // que l'on parcourt à la main.
      if (p.closest('.announcement-bar')) continue;
      activer(p);
    }
  }

  function demarrer() {
    balayer(document);

    // Les grilles se reconstruisent après un filtre, un tri ou l'ouverture
    // d'une fenêtre d'ajout rapide : on rattache le glissement aux nouvelles.
    if (typeof MutationObserver === 'function') {
      var obs = new MutationObserver(function (mutations) {
        for (var i = 0; i < mutations.length; i++) {
          var ajouts = mutations[i].addedNodes;
          for (var j = 0; j < ajouts.length; j++) {
            if (ajouts[j].nodeType === 1) balayer(ajouts[j]);
          }
        }
      });
      obs.observe(document.body, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', demarrer);
  } else {
    demarrer();
  }
})();
